const getInvoiceValueFromBasicPrice = ({ basicPrice, tcsPercentage }: { basicPrice: number; tcsPercentage: number }) => {
    basicPrice = Number(basicPrice);
    const gst = +(basicPrice * 0.18);
    const tcs = ((basicPrice + gst) * 1) / 100;
    return +(basicPrice + gst + tcs).toFixed(2);
};

export default getInvoiceValueFromBasicPrice;
